// Email Invite Reducer
import {
  PREVIEW_EMAIL_UPLOAD,
  PREVIEW_EMAIL_UPLOAD_SUCCESS,
  PREVIEW_EMAIL_UPLOAD_FAIL,
  PREVIEW_EMAIL_UPLOAD_RESET,
  CONFIRM_EMAIL_UPLOAD,
  CONFIRM_EMAIL_UPLOAD_SUCCESS,
  CONFIRM_EMAIL_UPLOAD_FAIL,
  CONFIRM_EMAIL_UPLOAD_RESET,
  GET_EMAIL_INVITES,
  GET_EMAIL_INVITES_SUCCESS,
  GET_EMAIL_INVITES_FAIL,
  GET_EMAIL_INVITES_RESET,
  GET_EMAIL_INVITE_STATS,
  GET_EMAIL_INVITE_STATS_SUCCESS,
  GET_EMAIL_INVITE_STATS_FAIL,
  GET_EMAIL_INVITE_STATS_RESET,
  GET_EMAIL_BATCHES,
  GET_EMAIL_BATCHES_SUCCESS,
  GET_EMAIL_BATCHES_FAIL,
  GET_EMAIL_BATCHES_RESET,
  RESEND_EMAIL,
  RESEND_EMAIL_SUCCESS,
  RESEND_EMAIL_FAIL,
  RESEND_EMAIL_RESET,
  RESEND_FAILED_EMAILS,
  RESEND_FAILED_EMAILS_SUCCESS,
  RESEND_FAILED_EMAILS_FAIL,
  RESEND_FAILED_EMAILS_RESET,
  BULK_RESEND_EMAILS,
  BULK_RESEND_EMAILS_SUCCESS,
  BULK_RESEND_EMAILS_FAIL,
  BULK_RESEND_EMAILS_RESET,
  DELETE_PARTICIPANT,
  DELETE_PARTICIPANT_SUCCESS,
  DELETE_PARTICIPANT_FAIL,
  DELETE_PARTICIPANT_RESET,
} from '../actions/emailInviteAction';

const initialState = {
  // Preview Upload
  previewEmailUploadState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  // Confirm Upload
  confirmEmailUploadState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  // Get Email Invites
  getEmailInvitesState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  // Get Email Invite Stats
  getEmailInviteStatsState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  // Get Email Batches
  getEmailBatchesState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  // Resend Email
  resendEmailState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  // Resend Failed Emails
  resendFailedEmailsState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  // Bulk Resend Emails
  bulkResendEmailsState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  // Delete Participant
  deleteParticipantState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
};

const emailInviteReducer = (state = initialState, action) => {
  switch (action.type) {
    // Preview Email Upload
    case PREVIEW_EMAIL_UPLOAD:
      return {
        ...state,
        previewEmailUploadState: {
          ...state.previewEmailUploadState,
          apiState: 'loading',
        },
      };
    case PREVIEW_EMAIL_UPLOAD_SUCCESS:
      return {
        ...state,
        previewEmailUploadState: {
          apiState: 'success',
          data: action.response,
          message: action.response?.message || 'File validated successfully',
          errors: action.response?.errors || null,
          error: null,
        },
      };
    case PREVIEW_EMAIL_UPLOAD_FAIL:
      return {
        ...state,
        previewEmailUploadState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || 'Failed to validate file',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case PREVIEW_EMAIL_UPLOAD_RESET:
      return {
        ...state,
        previewEmailUploadState: initialState.previewEmailUploadState,
      };

    // Confirm Email Upload
    case CONFIRM_EMAIL_UPLOAD:
      return {
        ...state,
        confirmEmailUploadState: {
          ...state.confirmEmailUploadState,
          apiState: 'loading',
        },
      };
    case CONFIRM_EMAIL_UPLOAD_SUCCESS:
      return {
        ...state,
        confirmEmailUploadState: {
          apiState: 'success',
          data: action.response,
          message: action.response?.message || 'Emails sent successfully',
          errors: action.response?.errors || null,
          error: null,
        },
      };
    case CONFIRM_EMAIL_UPLOAD_FAIL:
      return {
        ...state,
        confirmEmailUploadState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || 'Failed to send emails',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case CONFIRM_EMAIL_UPLOAD_RESET:
      return {
        ...state,
        confirmEmailUploadState: initialState.confirmEmailUploadState,
      };

    // Get Email Invites
    case GET_EMAIL_INVITES:
      return {
        ...state,
        getEmailInvitesState: {
          ...state.getEmailInvitesState,
          apiState: 'loading',
        },
      };
    case GET_EMAIL_INVITES_SUCCESS:
      return {
        ...state,
        getEmailInvitesState: {
          apiState: 'success',
          data: action.response,
          message: action.response?.message || 'Contacts retrieved',
          errors: action.response?.errors || null,
          error: null,
        },
      };
    case GET_EMAIL_INVITES_FAIL:
      return {
        ...state,
        getEmailInvitesState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || 'Failed to fetch contacts',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case GET_EMAIL_INVITES_RESET:
      return {
        ...state,
        getEmailInvitesState: initialState.getEmailInvitesState,
      };

    // Get Email Invite Stats
    case GET_EMAIL_INVITE_STATS:
      return {
        ...state,
        getEmailInviteStatsState: {
          ...state.getEmailInviteStatsState,
          apiState: 'loading',
        },
      };
    case GET_EMAIL_INVITE_STATS_SUCCESS:
      return {
        ...state,
        getEmailInviteStatsState: {
          apiState: 'success',
          data: action.response,
          message: action.response?.message || 'Stats retrieved',
          errors: action.response?.errors || null,
          error: null,
        },
      };
    case GET_EMAIL_INVITE_STATS_FAIL:
      return {
        ...state,
        getEmailInviteStatsState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || 'Failed to fetch stats',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case GET_EMAIL_INVITE_STATS_RESET:
      return {
        ...state,
        getEmailInviteStatsState: initialState.getEmailInviteStatsState,
      };

    // Get Email Batches
    case GET_EMAIL_BATCHES:
      return {
        ...state,
        getEmailBatchesState: {
          ...state.getEmailBatchesState,
          apiState: 'loading',
        },
      };
    case GET_EMAIL_BATCHES_SUCCESS:
      return {
        ...state,
        getEmailBatchesState: {
          apiState: 'success',
          data: action.response,
          message: action.response?.message || 'Batches retrieved',
          errors: action.response?.errors || null,
          error: null,
        },
      };
    case GET_EMAIL_BATCHES_FAIL:
      return {
        ...state,
        getEmailBatchesState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || 'Failed to fetch batches',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case GET_EMAIL_BATCHES_RESET:
      return {
        ...state,
        getEmailBatchesState: initialState.getEmailBatchesState,
      };

    // Resend Email
    case RESEND_EMAIL:
      return {
        ...state,
        resendEmailState: {
          ...state.resendEmailState,
          apiState: 'loading',
        },
      };
    case RESEND_EMAIL_SUCCESS:
      return {
        ...state,
        resendEmailState: {
          apiState: 'success',
          data: action.response,
          message: action.response?.message || 'Email resent successfully',
          errors: action.response?.errors || null,
          error: null,
        },
      };
    case RESEND_EMAIL_FAIL:
      return {
        ...state,
        resendEmailState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || 'Failed to resend email',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case RESEND_EMAIL_RESET:
      return {
        ...state,
        resendEmailState: initialState.resendEmailState,
      };

    // Resend Failed Emails
    case RESEND_FAILED_EMAILS:
      return {
        ...state,
        resendFailedEmailsState: {
          ...state.resendFailedEmailsState,
          apiState: 'loading',
        },
      };
    case RESEND_FAILED_EMAILS_SUCCESS:
      return {
        ...state,
        resendFailedEmailsState: {
          apiState: 'success',
          data: action.response,
          message: action.response?.message || 'Failed emails resent',
          errors: action.response?.errors || null,
          error: null,
        },
      };
    case RESEND_FAILED_EMAILS_FAIL:
      return {
        ...state,
        resendFailedEmailsState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || 'Failed to resend emails',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case RESEND_FAILED_EMAILS_RESET:
      return {
        ...state,
        resendFailedEmailsState: initialState.resendFailedEmailsState,
      };

    // Bulk Resend Emails
    case BULK_RESEND_EMAILS:
      return {
        ...state,
        bulkResendEmailsState: {
          ...state.bulkResendEmailsState,
          apiState: 'loading',
        },
      };
    case BULK_RESEND_EMAILS_SUCCESS:
      return {
        ...state,
        bulkResendEmailsState: {
          apiState: 'success',
          data: action.response,
          message: action.response?.message || 'Bulk resend completed',
          errors: action.response?.errors || null,
          error: null,
        },
      };
    case BULK_RESEND_EMAILS_FAIL:
      return {
        ...state,
        bulkResendEmailsState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || 'Failed to bulk resend emails',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case BULK_RESEND_EMAILS_RESET:
      return {
        ...state,
        bulkResendEmailsState: initialState.bulkResendEmailsState,
      };

    // Delete Participant
    case DELETE_PARTICIPANT:
      return {
        ...state,
        deleteParticipantState: {
          ...state.deleteParticipantState,
          apiState: 'loading',
        },
      };
    case DELETE_PARTICIPANT_SUCCESS:
      return {
        ...state,
        deleteParticipantState: {
          apiState: 'success',
          data: action.response,
          message: action.response?.message || 'Participant removed',
          errors: action.response?.errors || null,
          error: null,
        },
      };
    case DELETE_PARTICIPANT_FAIL:
      return {
        ...state,
        deleteParticipantState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || 'Failed to remove participant',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case DELETE_PARTICIPANT_RESET:
      return {
        ...state,
        deleteParticipantState: initialState.deleteParticipantState,
      };

    default:
      return state;
  }
};

export default emailInviteReducer;
